import Vue from 'vue'
import {POSITION, TYPE} from "vue-toastification";

export default {
    state: {
        message: null,
        type: null,
    },
    mutations: {
        setMessage(state, message) {
            if (message == null)
                state.message = null;
            else {
                state.message = message.message;
                state.type = message.type;
                let type = TYPE.SUCCESS
                if (message.type === 'danger')
                    type = TYPE.ERROR
                if (message.type === 'warning')
                    type = TYPE.WARNING
                Vue.$toast(state.message, {
                    position: POSITION.BOTTOM_RIGHT,
                    type: type
                })
            }
        }
    },
    actions: {
        messageAction({commit}, message) {
            if (!message.message)
                message = {
                    message,
                    type: 'info'
                }
            commit('setMessage', message);
        },
        handleErrorAction({dispatch}, err) {
            let msg = '';
            let type = 'danger';
            if (err.response) {
                // client received an error response (5xx, 4xx)
                msg = err.response.data;
                if (err.response.status < 500)
                    type = 'warning';
            } else if (err.request) {
                // client never received a response, or request never left
                msg = 'Die Sandkastenliga antwortet nicht. Bitte versuche es später noch einmal.';
            } else {
                // anything else
                msg = 'Ein unerwarteter Fehler ist aufgetreten. Bitte kontaktiere die Admins!';
            }
            dispatch('messageAction', {
                message: msg,
                type: type
            });
            if (type !== 'info') {
                // log error in GA
                // let action = err.config ? err.config.url : (this.loggedIn ? this.user.id + ' action' : 'unknown action');
                // event(type, action, msg, err.response ? err.response.status : -1);
            }
        },
        clearAction({commit}) {
            commit('setMessage', null);
        }
    },
    getters: {
        message(state) {
            return state.message;
        },
        messageType(state) {
            return state.type;
        }
    }
}
